import { Paper } from "@material-ui/core";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import jwt_decode from "jwt-decode";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { REACT_DASHBOARD_PANEL } from "../../actions/EndPoints";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import Toast from "../../components/ToastContainer/CustomToast";
import TitleBar from "../../components/v4/TitleBar";
import {
  createSettings,
  getListSettingsById,
  updateSettings,
} from "../../slices/AdditionalSettings/AdditionalSettingsSlice";
import CommonUtil from "../../Util/CommonUtils";
import GlobalDataContext from "../GlobalDataContext";

import { useContext } from "react";
import HeaderToolbar from "../../components/HeaderToolbar";

// Default visitor reminder time (minutes); was "60"
const DEFAULT_REMINDER = "60";

function DateFormatForHqAndDealer() {
  var decoded_jwtToken = jwt_decode(
    localStorage.getItem(process.env.REACT_APP_ACCESS_TOKEN),
  );
  const companyId = localStorage.getItem("companyId");
  const { setCompanySettings } = useContext(GlobalDataContext);
  const { t } = useTranslation();
  let history = useHistory();
  const dispatch = useDispatch();
  const [close, setclose] = useState();
  const [selectedValue, setSelectedValue] = useState(null);
  const [payload, setPayload] = useState({
    id: "",
    adminAndDealerDateFormat: "",
    companyId: decoded_jwtToken.companyId,
    dateFormat: "MM-DD-YYYY",
    invitationCodeDigits: "",
    walkInCodeDigits: "",
    selfRegistartionCodeDigits: "",
    invitationScanLimit: "2",
    walkInScanLimit: "2",
    selfRegistartionScanLimit: "2",
    invitationIntervalTime: "30",
    walkInIntervalTime: "30",
    selfIntervalTime: "30",
    invitationEarlyCheckInTime: "30",
    invitationLateCheckOutTime: "30",
    walkInEarlyCheckInTime: "30",
    walkInLateCheckOutTime: "30",
    selfEarlyCheckInTime: "30",
    selfLateCheckOutTime: "30",
    printerDevice: "Kiosk",
    invitationVerifyMode: "QRCODE",
    walkInRegistartionVerifyMode: "QRCODE",
    selfRegistartionVerifyMode: "QRCODE",
    viewedVersion: "",
    defaultHostId: "",
    visitorSendNotificationReminder: DEFAULT_REMINDER,
  });
  const [error, setError] = useState({ dateFormat: false });

  const dateformat = [
    { label: "DD-MM-YYYY" },
    { label: "MM-DD-YYYY" },
    { label: "YYYY-MM-DD" },
  ];

  const reminderOptions = [
    // { label: "15 Minutes", value: "15" },
    // { label: "30 Minutes", value: "30" },
    // { label: "45 Minutes", value: "45" },
    { label: "60 Minutes", value: "60" },
    // { label: "5 Minutes", value: "5" },
  ];

  const findReminderOption = (value) =>
    reminderOptions.find((item) => item.value === String(value)) ||
    reminderOptions.find((item) => item.value === DEFAULT_REMINDER);

  const [selectedReminder, setSelectedReminder] = useState(
    findReminderOption(DEFAULT_REMINDER),
  );

  const handleReminderChange = (event, newValue) => {
    const option = newValue || findReminderOption(DEFAULT_REMINDER);
    setSelectedReminder(option);
    setPayload({
      ...payload,
      visitorSendNotificationReminder: option.value,
    });
  };

  const handleDateFormat = (event, newValue) => {
    if (newValue === null) {
      setclose();
      setSelectedValue(null);
      setPayload({
        ...payload,
        adminAndDealerDateFormat: "",
      });
    } else {
      setSelectedValue(newValue);
      setPayload({
        ...payload,
        adminAndDealerDateFormat: newValue.label,
      });
    }
  };

  useEffect(() => {
    loadSetting();
  }, []);

  const loadSetting = () => {
    dispatch(getListSettingsById(companyId))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0000") {
          setPayload({
            ...payload,
            adminAndDealerDateFormat: data.data.adminAndDealerDateFormat,
            id: data.data.id,
            viewedVersion: data.data.viewedVersion,
            defaultHostId: data.data.defaultHostId,
            visitorSendNotificationReminder: findReminderOption(
              data.data.visitorSendNotificationReminder,
            ).value,
          });
          setSelectedReminder(
            findReminderOption(data.data.visitorSendNotificationReminder),
          );
          let dateFormat = dateformat.find((item) => {
            return item.label === data.data.adminAndDealerDateFormat;
          });
          setSelectedValue(dateFormat);
        }
      });
  };

  const handleSubmit = () => {
    if (payload.adminAndDealerDateFormat === "") {
      setError({ adminAndDealerDateFormat: true });
      Toast(t("DATEFORMATSELECT"), "error");
      return;
    }
    if (CommonUtil.isEmptyString(payload.id)) {
      var requestBody = {
        adminAndDealerDateFormat: payload.adminAndDealerDateFormat,
        companyId: decoded_jwtToken.companyId,
        dateFormat: payload.dateFormat,
        invitationCodeDigits: payload.invitationCodeDigits,
        walkInCodeDigits: payload.walkInCodeDigits,
        selfRegistartionCodeDigits: payload.selfRegistartionCodeDigits,
        invitationScanLimit: payload.invitationScanLimit,
        walkInScanLimit: payload.walkInScanLimit,
        selfRegistartionScanLimit: payload.selfRegistartionScanLimit,
        invitationIntervalTime: payload.invitationIntervalTime,
        walkInIntervalTime: payload.walkInIntervalTime,
        selfIntervalTime: payload.selfIntervalTime,
        invitationEarlyCheckInTime: payload.invitationEarlyCheckInTime,
        invitationLateCheckOutTime: payload.invitationLateCheckOutTime,
        walkInEarlyCheckInTime: payload.walkInEarlyCheckInTime,
        walkInLateCheckOutTime: payload.walkInLateCheckOutTime,
        selfEarlyCheckInTime: payload.selfEarlyCheckInTime,
        selfLateCheckOutTime: payload.selfLateCheckOutTime,
        printerDevice: payload.printerDevice,
        invitationVerifyMode: payload.invitationVerifyMode,
        walkInRegistartionVerifyMode: payload.walkInRegistartionVerifyMode,
        selfRegistartionVerifyMode: payload.selfRegistartionVerifyMode,
        visitorSendNotificationReminder:
          payload.visitorSendNotificationReminder,
      };
      dispatch(createSettings(requestBody))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0063") {
            Toast(t("SETTINGSUCCESS"), "success");
            setCompanySettings(data.data);
            localStorage.setItem("companySettings", JSON.stringify(data.data));
          } else if (data.code === "CVAW0064") {
            Toast("Settings already present", "error");
            setCompanySettings(data.data);
            localStorage.setItem("companySettings", JSON.stringify(data.data));
          } else {
            Toast(data.message, "error");
          }
        });
    } else {
      dispatch(updateSettings(payload))
        .unwrap()
        .then((data) => {
          if (data.code === "CVAI0071") {
            Toast(t("SETTINGUPDATESUCCESS"), "success");
            setCompanySettings(data.data);
            localStorage.setItem("companySettings", JSON.stringify(data.data));
          } else if (data.code === "CVAW0064") {
            setCompanySettings(data.data);
            localStorage.setItem("companySettings", JSON.stringify(data.data));
            Toast(t("SETTINGALREADY"), "error");
          } else {
            Toast(data.message, "error");
          }
        })
        .catch((er) => {});
    }
  };

  const handleCancel = () => {
    history.push({
      pathname: REACT_DASHBOARD_PANEL,
    });
  };

  return (
    <>
      <Grid
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <HeaderToolbar title={t("APRMODE2")} />
        </Box>
      </Grid>
      <Paper
        style={{
          height: "calc(100vh - 150px)",
          marginTop: "20px",
        }}
      >
        <Grid
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "30px",
            paddingRight: "0px",
            width: 600,
          }}
        >
          <Grid item xs={12} sm={9}>
            <Autocomplete
              popupIcon={<ExpandMoreIcon />}
              noOptionsText={"No Options found"}
              onChange={handleDateFormat}
              options={dateformat}
              value={selectedValue}
              getOptionLabel={(option) => option?.label || ""}
              isOptionEqualToValue={(option, value) =>
                option?.label === value?.label
              }
              renderInput={(params) => (
                <TextField {...params} label={t("APRMODE3")} />
              )}
              slotProps={{
                paper: {
                  sx: {
                    "&.MuiAutocomplete-option[aria-selected='true']": {
                      backgroundColor: "red",
                      color: "yellow",
                      "&:hover": {
                        backgroundColor: "darkred",
                      },
                    },
                  },
                },
              }}
            />
          </Grid>
          {decoded_jwtToken.companyType === "NONE" && (
            <Grid item xs={12} sm={9} style={{ marginTop: "30px" }}>
              <Autocomplete
                popupIcon={<ExpandMoreIcon />}
                noOptionsText={"No Options found"}
                disableClearable
                onChange={handleReminderChange}
                options={reminderOptions}
                value={selectedReminder}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Visitor Reminder Notification"
                  />
                )}
              />
            </Grid>
          )}

          <Grid
            container
            spacing={1}
            style={{
              width: 600,
              marginTop: "30px",
              display: "flex",
              justifyContent: "end",
              paddingRight: "25px",
            }}
          >
            <Grid item>
              <CancelButtons
                onClick={handleCancel}
                color="secondary"
                variant="contained"
              >
                <Typography>{t("COMMON008")}</Typography>
              </CancelButtons>
            </Grid>
            <Grid item>
              <SubmitButtons onClick={handleSubmit} variant="contained">
                <Typography>{t("COMMON007")}</Typography>
              </SubmitButtons>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
}

export default DateFormatForHqAndDealer;
